export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.11.4-0621.25",
  commitId: "5f4ff0a6e3a592e6892f29b71b02a32251eb45a5",
  commitTime: "2026-11-04T06:21:25.000Z",
});
